import { translation } from '@hh.ru/front-static-app';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Form from 'src/components/Form';

import styles from 'src/components/Logout/logout.less';

const TrlKeys = {
    logout: 'statportal.logout',
};

const Logout: TranslatedComponent = ({ trls }) => {
    return (
        <Form action="/account/logout" method="POST">
            <input className={styles.logout} type="submit" value={trls[TrlKeys.logout]} data-qa="logout" />
        </Form>
    );
};

export default translation(Logout);
